import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import "./Input.css";
import { TbSearch } from "react-icons/tb";
import { Container, Flex } from "../../layout";
import { Text } from "../";

function Input({
  label,
  type = "text",
  placeholder = "",
  width = "100%",
  onChange,
  children,
  id,
  name,
  maxLength,
  className,
  value,
  resize = "none",
  disabled = false,
}) {
  const [isActive, setIsActive] = useState(false);
  const inputRef = useRef(null);

  // Fonction pour activer l'input lors d'un clic sur le conteneur
  const handleFocus = () => {
    setIsActive(true);
    inputRef.current?.focus();
  };

  return (
    <Container className={`Input ${className}`} style={{ width: width }}>
      {/* Affiche le label si fourni */}
      {label && (
        <Text size="sm" className="text-sm" onClick={handleFocus}>
          {label}
        </Text>
      )}
      <Flex
        className={`container ${isActive ? "active" : ""}`}
        onClick={handleFocus}
      >
        {/* Affiche des éléments enfants si fournis */}
        {children}

        {/* Affiche l'icône de recherche si le type est "search" */}
        {type === "search" && <TbSearch className="icon" />}

        {/* Affiche un textarea ou un input selon le type */}
        {type === "textarea" ? (
          <textarea
            ref={inputRef}
            id={id}
            placeholder={placeholder}
            onChange={onChange}
            maxLength={maxLength}
            value={value}
            style={{ resize: resize }}
            name={name}
            disabled={disabled}
            onFocus={() => setIsActive(true)}
            onBlur={() => setIsActive(false)}
          />
        ) : (
          <input
            ref={inputRef}
            type={type}
            id={id}
            placeholder={placeholder}
            onChange={onChange}
            maxLength={maxLength}
            value={value}
            name={name}
            disabled={disabled}
            onFocus={() => setIsActive(true)}
            onBlur={() => setIsActive(false)}
          />
        )}
      </Flex>
    </Container>
  );
}

Input.propTypes = {
  label: PropTypes.string, // Label affiché au-dessus de l'input
  type: PropTypes.string, // Type de l'input (text, search, textarea, etc.)
  placeholder: PropTypes.string, // Texte affiché dans l'input lorsqu'il est vide
  width: PropTypes.string, // Largeur du composant
  onChange: PropTypes.func, // Fonction appelée lors d'un changement de valeur
  children: PropTypes.node, // Éléments enfants à afficher à côté de l'input
  id: PropTypes.string, // ID unique de l'input
  name: PropTypes.string, // Nom de l'input
  maxLength: PropTypes.number, // Longueur maximale du texte
  value: PropTypes.oneOfType([
    // Valeur de l'input
    PropTypes.string,
    PropTypes.number,
  ]),
  resize: PropTypes.oneOf(["none", "both", "horizontal", "vertical"]), // Redimensionnement autorisé pour les textarea
  disabled: PropTypes.bool, // Désactive l'input si true
};

export default Input;
